import { http } from '../helpers/axiosHelper';
export default class StepTemplateService {
   async searchStepTemplates(body: Object) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/step-template', {
            params: body,
         })
         .then((response) => {
            return response.data;
         });
   }

   async createTemplate(body: Object) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/step-template', body, { params: { include: 'slaves' } })
         .then((response) => {
            return response.data;
         });
   }

   async patchTemplate(templateId: number, path: string, value: any) {
      const body = {
         path,
         value,
         op: 'replace',
      };
      return await http.patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/step-template/' + templateId, [body]).then((response) => {
         return response.data;
      });
   }
}
